var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41085 1.14062C5.73629 0.815186 6.26393 0.815186 6.58937 1.14062L11.4505 6.00173C11.6068 6.15801 11.6946 6.36998 11.6946 6.59099C11.6946 6.812 11.6068 7.02397 11.4505 7.18025L6.58937 12.0414C6.26393 12.3668 5.73629 12.3668 5.41085 12.0414C5.08542 11.7159 5.08542 11.1883 5.41085 10.8628L8.84938 7.42432H1.139C0.67876 7.42432 0.305664 7.05123 0.305664 6.59099C0.305664 6.13075 0.67876 5.75766 1.139 5.75766H8.84938L5.41085 2.31913C5.08542 1.9937 5.08542 1.46606 5.41085 1.14062Z",
    fill: "#040435"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFill);
export default __webpack_public_path__ + "static/media/arrow-right-fill.2a5c56373818d64d4ffac0d009f229bc.svg";
export { ForwardRef as ReactComponent };